function bubbles() {
    document.querySelectorAll('.zubehoer-item').forEach(function(item) {
        const bubble = item.querySelector('.bubble');
        const liElement = item.querySelector('.product');

        bubble.addEventListener('click', function() {
            // Prüfen, ob das aktuelle Element bereits sichtbar ist
            const isCurrentlyVisible = liElement.style.display === 'flex';

            // Alle <li>-Elemente verstecken
            document.querySelectorAll('.zubehoer-item .product').forEach(function(li) {
                li.style.display = 'none';
            });

            // Falls das aktuelle Element nicht sichtbar war, zeige es an, sonst bleibt es versteckt
            liElement.style.display = isCurrentlyVisible ? 'none' : 'flex';
        });
    });
}

export { bubbles };
